export const defaultProps = {
  anchorPositionOffset: { x: 5, y: 5 },
  withoutStopPropagation: false,
};

export const initialState = {
  anchorPosition: null,
  anchorEl: null,
};
